import ToggleFFXIV from '@/app/components/ToggleFFXIV';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useTranslation } from '@/hooks/useTranslation';
import React from 'react'

const TimerSelector = () => {
    const { t } = useTranslation();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSetting, isGameMaster } = useGameModeSettingsContext();

    const value = settings.timerSeconds;

    const handleTimerChange = (newSeconds: number | null) => {
        if (isGameMaster) {
            updateSetting('timerSeconds', newSeconds);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <ToggleFFXIV
            value={value === null}
            onChange={(val) => handleTimerChange(val ? null : 60)}
            text={t('game.config.advancedSettings.noTimer')}
            shape="square"
        />
    )
}

export default TimerSelector